import { render, staticRenderFns } from "./FieldSelector.vue?vue&type=template&id=511fbff9&scoped=true&"
import script from "./FieldSelector.vue?vue&type=script&lang=js&"
export * from "./FieldSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511fbff9",
  null
  
)

export default component.exports